import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { hasRejectedTailorings } from "./controller/has-rejected-tailorings"
import { useEffect } from "react"
import { DisableNextRegimeStep } from "routes/regime/plugins/publishing/publishing-event-definitions.mjs"
import { IS_LOADING, returnIsLoadingOnEachRequest } from "lib/graphql/return-is-loading-on-each-request"

const TAILORING_REJECTION_EVENT_ID = "tailoringRejection"

export function TailoringRejections({ children, step, message }) {
    const { parentItem, activeStep } = useBoundContext()

    const isAvailable = activeStep.props.available()
    const version = typeof isAvailable === "number" && !Number.isNaN(isAvailable) ? isAvailable : 0

    const hasRejectionResult = hasRejectedTailorings.useResults(parentItem?.id, version, returnIsLoadingOnEachRequest())
    const disabled = hasRejectionResult === IS_LOADING || (hasRejectionResult ?? false)

    useEffect(disableNextRegimeStep, [disabled, step, message])

    return children

    function disableNextRegimeStep() {
        DisableNextRegimeStep(step).raise({
            id: TAILORING_REJECTION_EVENT_ID,
            disabled,
            message:
                message ?? "You can't proceed while there are unresolved rejections. Please resolve them to continue.",
        })

        return () => {
            DisableNextRegimeStep(step).raise({ id: TAILORING_REJECTION_EVENT_ID, disabled: false })
        }
    }
}
